import './polyfills';
import './instrument';
import '@/core/lib/api-client';
import '@/core/lib/cloudflare-worker-reverse-proxy';

import { createRoot } from 'react-dom/client';
import { migrateToIndexedDB } from './scripts/migrate-to-indexeddb';
import { isPublicPageRoute } from '@/core/utils/is-public-page-route';
import { initConsentPurge } from '@/core/consent/purge-storage';
import Entry from './app/Entry';
import './index.scss';

initConsentPurge();

createRoot(document.getElementById('root')!).render(<Entry />);

if (!isPublicPageRoute()) {
  migrateToIndexedDB();
}
